import { render, staticRenderFns } from "./SuggestedSkills.vue?vue&type=template&id=6674b318&scoped=true&"
import script from "./SuggestedSkills.vue?vue&type=script&lang=js&"
export * from "./SuggestedSkills.vue?vue&type=script&lang=js&"
import style0 from "./SuggestedSkills.vue?vue&type=style&index=0&id=6674b318&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6674b318",
  null
  
)

export default component.exports